/* Editor's pick mobile carousel:
   Only the active card contributes height. Other cards keep their width for
   horizontal snap, but height:0 so the page does not grow to the tallest
   product (the big overflow under the feed / footer).

   Stories/dots hidden by the category filter bar (editors-pick.liquid sets
   the `hidden` attribute) are re-queried on every pass instead of cached
   once at init, so the swipe index math lines up with what is actually on
   screen after a filter change instead of leaving gaps or landing on a
   hidden card. */
(function () {
  var MQ = '(max-width: 749px)';

  function init(root) {
    if (root.dataset.jjvStoriesReady) return;
    root.dataset.jjvStoriesReady = '1';

    var list = root.querySelector('.jjv-stories__list');
    if (!list) return;

    var allStories = Array.prototype.slice.call(list.querySelectorAll('.jjv-story'));
    if (!allStories.length) return;

    var dotsWrap = root.querySelector('[data-jjv-stories-dots]');

    function visibleStories() {
      return allStories.filter(function (story) {
        return !story.hidden;
      });
    }

    function visibleDots() {
      if (!dotsWrap) return [];
      return Array.prototype.slice
        .call(dotsWrap.querySelectorAll('[data-jjv-stories-dot]'))
        .filter(function (dot) {
          var li = dot.closest('li');
          return !li || !li.hidden;
        });
    }

    var mq = window.matchMedia(MQ);
    var raf = 0;
    var lastIndex = -1;

    function activeIndex(stories) {
      var width = list.clientWidth || 1;
      return Math.max(0, Math.min(stories.length - 1, Math.round(list.scrollLeft / width)));
    }

    function syncDots(dots, index) {
      if (!dots.length) return;
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function syncActive() {
      var stories = visibleStories();
      var dots = visibleDots();

      if (!mq.matches) {
        allStories.forEach(function (story) {
          story.classList.remove('is-active');
          story.classList.remove('is-inactive');
        });
        list.style.height = '';
        syncDots(dots, 0);
        lastIndex = -1;
        document.documentElement.classList.remove('jjv-stories-mobile');
        return;
      }

      document.documentElement.classList.add('jjv-stories-mobile');

      if (!stories.length) {
        allStories.forEach(function (story) {
          story.classList.remove('is-active');
          story.classList.remove('is-inactive');
        });
        list.style.height = '';
        return;
      }

      var index = activeIndex(stories);
      stories.forEach(function (story, i) {
        var on = i === index;
        story.classList.toggle('is-active', on);
        story.classList.toggle('is-inactive', !on);
      });
      allStories.forEach(function (story) {
        if (story.hidden) {
          story.classList.remove('is-active');
          story.classList.remove('is-inactive');
        }
      });

      // Explicit height from the active card after inactive ones collapse.
      list.style.height = '';
      var active = stories[index];
      if (active) list.style.height = active.offsetHeight + 'px';

      if (index !== lastIndex) {
        lastIndex = index;
        syncDots(dots, index);
      }
    }

    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        raf = 0;
        syncActive();
      });
    }

    function goTo(index) {
      if (!mq.matches) return;
      var width = list.clientWidth;
      list.scrollTo({ left: width * index, behavior: 'smooth' });
    }

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-jjv-stories-dot]');
        if (!dot) return;
        var index = visibleDots().indexOf(dot);
        if (index > -1) goTo(index);
      });
    }

    list.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', schedule);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(schedule);
    }

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(schedule);
      allStories.forEach(function (story) {
        ro.observe(story);
      });
    }

    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', schedule, { once: true });
    });

    // The category filter bar (editors-pick.liquid) toggles `hidden` on
    // stories/dots then fires this, so the swipe index recalculates against
    // only the cards currently visible instead of the full original set.
    root.addEventListener('jjv:stories:filtered', function () {
      lastIndex = -1;
      schedule();
    });

    syncActive();
  }

  function boot() {
    document.querySelectorAll('.jjv-stories').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.jjv-stories')
      : null;
    if (root) {
      delete root.dataset.jjvStoriesReady;
      init(root);
    }
  });
})();
